import React from 'react';
import { Flex } from 'rebass';

const Frame: React.FC<any> = ({ children, ...props }): JSX.Element => (
  <Flex
    width="100%"
    justifyContent="center"
    m="auto"
    px={[4, 4, 0]}
    css="max-width: 1190px; white-space: pre-wrap;"
    {...props}
  >
    {children}
  </Flex>
);

export default Frame;
